import { useRuntimeBrandStore } from '@core/store/runtimeBrandStore';

export function useRuntimeBrand() {
  const logoUrl = useRuntimeBrandStore((s) => s.logoUrl);
  const brandName = useRuntimeBrandStore((s) => s.brandName);
  const businessAddress = useRuntimeBrandStore((s) => s.businessAddress);
  const businessPhone = useRuntimeBrandStore((s) => s.businessPhone);
  const socialLinks = useRuntimeBrandStore((s) => s.socialLinks);
  const businessEmail = useRuntimeBrandStore((s) => s.businessEmail);
  const supportPhone = useRuntimeBrandStore((s) => s.supportPhone);
  const whatsappNumber = useRuntimeBrandStore((s) => s.whatsappNumber);
  const privacyPolicy = useRuntimeBrandStore((s) => s.privacyPolicy);
  const termsAndConditions = useRuntimeBrandStore((s) => s.termsAndConditions);
  const aboutUs = useRuntimeBrandStore((s) => s.aboutUs);
  const poweredBy = useRuntimeBrandStore((s) => s.poweredBy);
  return {
    logoUrl,
    brandName,
    businessAddress,
    businessPhone,
    socialLinks,
    businessEmail,
    supportPhone,
    whatsappNumber,
    privacyPolicy,
    termsAndConditions,
    aboutUs,
    poweredBy,
  };
}
